import React from 'react';
import PropTypes from 'prop-types';
import { iconBranching } from 'utils/svgConstants';
import Assigner from './Assigner';

const BranchAssignments = ({ activeBranches, branchMembership, branchingQuestion, fieldId, toggleBranchMembership }) => (
  <div className="container">
    <div className="row">
      <div className="col">
        <div className="bg-branching-green d-flex align-items-center p-2">
          <div className="mr-2 font-weight-bold">Branching Assignments</div>
          <svg className="fill-branching-green mr-2" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
            <g transform="rotate(270, 256, 256)">
              <path d={iconBranching} />
            </g>
          </svg>
          <small className="font-italic">All questions must be assigned to at least one branch</small>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col">
        {activeBranches[branchingQuestion.id].map(({ value, index }) => (
          <Assigner
            key={value}
            keyPath={[fieldId, 'branch-assigner', value]}
            onBranchAssignment={() => toggleBranchMembership(fieldId, value, branchingQuestion.id)}
            fieldValue={value}
            branchId={index + 1}
            branchingFieldName={branchingQuestion.name}
            checked={branchMembership.includes(value)}
          />
        ))}

      </div>
    </div>
  </div>
);
BranchAssignments.propTypes = {
  activeBranches: PropTypes.object.isRequired,
  branchMembership: PropTypes.array.isRequired,
  branchingQuestion: PropTypes.object.isRequired,
  fieldId: PropTypes.string.isRequired,
  toggleBranchMembership: PropTypes.func.isRequired,
};

export default BranchAssignments;
